import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { eq } from 'ember-truth-helpers'
import { RolloverState } from 'teacher-ui-client/school-rollover/manage-rollover-states'

interface Signature {
  Element: HTMLDivElement
  Args: {
    status?: RolloverState
  }
}

export const RolloverStatus: TOC<Signature> = <template>
  <div class="text-center" data-test-rollover-status ...attributes>
    {{t "manage.rollover.status.title"}}:
    {{#if (eq @status RolloverState.Open)}}
      <span class="text-forest-green-350 mx-3 font-bold" data-test-rollover-status-open>
        {{t "manage.rollover.status.open"}}
      </span>
    {{else if (eq @status RolloverState.InProgress)}}
      <span class="text-oceany-blue-350 mx-3 font-bold" data-test-rollover-status-in-progress>
        {{t "manage.rollover.status.inProgress"}}
      </span>
    {{else if (eq @status RolloverState.Locked)}}
      <span class="text-watermelony-red-350 mx-3 font-bold" data-test-rollover-status-locked>
        {{t "manage.rollover.status.locked"}}
      </span>
    {{/if}}
  </div>
</template>

export default RolloverStatus
